<template>
  <div>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-- Seleção de Produto (agora somente exibição) -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Produto</span>
          <div class="w-full p-2 border rounded bg-gray-100"
            style="min-height:2.5rem; display:flex; align-items:center;">
            {{ dados.nomeProduto || 'Nenhum produto selecionado' }}
          </div>
        </div>
      </div>

      <!-- Campo Categoria -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Categoria</span>
          <vs-input class="w-full" name="categoria" id="categoria" v-model="form.categoria"
            v-validate="{ required: true }" :state="validateState('categoria')" :danger="validateClass('categoria')"
            val-icon-danger="clear" danger-text="Preencha este campo" />
        </div>
      </div>

      <!-- Valor de Venda -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Valor de Venda</span>
          <money class="w-full vs-inputx vs-input--input large" v-model="form.valorVenda" v-bind="moneyConfig"
            name="valorVenda" id="valorVenda" v-validate="{ required: true }" :state="validateState('valorVenda')"
            :danger="validateClass('valorVenda')" val-icon-danger="clear" danger-text="Preencha este campo" />
        </div>
      </div>

      <!-- Botões -->
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="warning" class="mr-3" @click.stop.prevent="onReset" type="border">
            Cancelar
          </vs-button>
          <vs-button type="filled" color="success" native-type="submit">
            Adicionar
          </vs-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { Money } from 'v-money';
import service from '@/services';

export default {
  props: {
    sideBar: Boolean,
    dados: Object,
    contadorRender: Number,
    produtos: {
      type: Array,
      default: () => []
    }
  },
  components: { vSelect, Money },
  data() {
    return {
      produtos: [],
      form: {
        idProduto: null,
        categoria: '',
        valorVenda: null,
        status: 1,
      },
      moneyConfig: {
        decimal: ',', thousands: '.', precision: 2, masked: true
      }
    };
  },
  mounted() {
    this.loadProdutos();
  },
  methods: {
    async loadProdutos() {
      const res = await service.post('Produtos', 'Listar', { filtrarpor: 'ativo' });
      this.produtos = res.data;
    },
    validateState(field) {
      const f = this.$validator.fields.find({ name: field });
      return f && (f.validated || f.dirty) ? !this.$validator.errors.has(field) : null;
    },
    validateClass(field) {
      const f = this.$validator.fields.find({ name: field });
      return f && (f.validated || f.dirty) ? this.$validator.errors.has(field) : false;
    },
    async checkProductExists(idProduto) {
      const res = await service.post('ProdutosShopping', 'VerificarExistencia', {
        idProduto
      });

      if (res.existe) {
        return false;
      }

      return true;
    },
    async onSubmit() {
      const fields = [this.form.categoria, this.form.valorVenda];

      const anyEmptyField = fields.some(field =>
        field === null || field === undefined || field === '' ||
        (typeof field === 'string' && field.trim() === '')
      );

      if (anyEmptyField) {
        this.$vs.notify({
          title: 'Aviso',
          text: 'Preencha todos os campos antes de enviar.',
          color: 'danger',
          position: 'top-center'
        });
        return;
      }

      const canInsert = await this.checkProductExists(this.dados.idProduto);
      if (!canInsert) {
        this.$vs.notify({
          title: 'Aviso',
          text: 'Este produto já está cadastrado no shopping.',
          color: 'warning',
          position: 'top-center'
        });
        return
      };

      this.$validator.validateAll().then(async valid => {
        if (!valid) return;

        try {
          const payload = {
            idProduto: this.dados.idProduto,
            valorVenda: this.form.valorVenda,
            status: this.form.status,
            categoria: this.form.categoria,
            idEmpresa: this.form.idEmpresa
          };

          const res = await service.put('ProdutosShopping', 'Adicionar', payload);

          this.$vs.notify({
            title: 'Sucesso',
            text: 'Produto adicionado ao shopping.',
            color: 'success',
            position: 'top-center'
          });

          this.$emit('done');
        } catch (e) {
          console.error(e);
          this.$vs.notify({
            title: 'Erro',
            text: e.errorMessage || 'Falha ao adicionar o produto.',
            color: 'danger',
            position: 'top-center'
          });
        }
      });
    },

    onReset() {
      this.form = { idProduto: null, valorVenda: null, categoria: '' };
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped>
#fileInput {
  display: none;
}

.img label {
  width: 100%;
  font-weight: normal;
}

.img .containericone {
  text-align: center;
  border-radius: 10px;
  padding: 10px 20px;
  -webkit-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  width: min-content;
  margin-top: 25px;
  margin-left: 43%;
  border: 1px solid #ccc;
}

.img .icone {
  font-size: 50px;
  color: #333;
}

.input-group-color {
  display: flex !important;
  gap: 5px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.color-picker {
  max-width: 2.5rem;
  height: 2.375rem;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}

.span-sub {
  color: rgb(60, 60, 60);
  font-size: 11px;
  margin-bottom: 5px;
}
</style>
